import { render, staticRenderFns } from "./Closure.vue?vue&type=template&id=64a302b0&lang=html&"
import script from "./Closure.vue?vue&type=script&lang=js&"
export * from "./Closure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports